import styled from '@emotion/styled';
import { ToolTip } from '@components/common/tooltip';
import { ThemeProps } from '@theme/base';
import { ZIndex } from './z-index';

export const FiltersBarHeading = styled.h5(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.labels.default as any),
  margin: 0,
  marginBottom: theme.custom.spacing.xSmall,

  ['span']: {
    ...(theme.custom.typography.labels.attribute as any),
    fontWeight: 'normal',
    cursor: 'default',

    ['&:hover']: {
      color: theme.custom.colors.group4.light
    }
  }
}));

export const FilterToolTip: any = styled(ToolTip)(({ theme }: ThemeProps) => ({
  marginLeft: theme.custom.spacing.xSmall,

  ['i']: {
    fontSize: 14,
    color: theme.custom.colors.group1.base
  },

  ['.react-tooltip-lite, .react-tooltip-lite-arrow']: {
    zIndex: `${ZIndex.TOOLTIP} !important` as any
  }
}));

export const FilterTooltipContent: any = styled.div({
  maxWidth: 200
});

export const FilterSubHeading = styled.p(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any)
}));

export const getFilterPaddingMixin = (theme: any, isLeftFilter?: boolean) => ({
  padding: isLeftFilter
    ? `${theme.custom.spacing.medium}px ${theme.custom.spacing.medium * 2}px ${theme.custom.spacing.medium}px 0`
    : theme.custom.spacing.medium
});
